import { Check } from 'lucide-react';

export interface CaseStudy {
  client: string;
  logo: string;
  sector: string;
  /** Gradient tone class for the sector chip and accent bar (g-blue, …). */
  tone: string;
  title: string;
  body: string;
  metric: string;
  metricLabel: string;
}

export function CaseCard({ study, delay }: { study: CaseStudy; delay?: number }): React.JSX.Element {
  return (
    <article className="case-card reveal" data-spotlight data-delay={delay}>
      <span className={`case-accent ${study.tone}`} aria-hidden="true" />

      <div className="case-top">
        <img src={study.logo} alt={study.client} loading="lazy" height={30} />
        <span className={`case-sector ${study.tone}`}>{study.sector}</span>
      </div>

      <h3 className="h3">{study.title}</h3>
      <p>{study.body}</p>

      <div className="case-outcome">
        <span className="case-outcome-icon" aria-hidden="true">
          <Check size={12} strokeWidth={3} />
        </span>
        <span className="metric">{study.metric}</span>
        <span className="metric-label">{study.metricLabel}</span>
      </div>
    </article>
  );
}
